module.exports = __webpack_public_path__ + "img/upload-add.602da133.svg";